/**
 * Groups users by their role (tag) assignments.
 *
 * @param {Array} allUsers - Array of user privilege objects from scheduleCalendarReducer.allUsers.users
 * @param {Array} roles - Array of role/tag objects from appReducer.roles.data
 * @returns {{ byRole: Object.<number, Array>, unassigned: Array }}
 *   - byRole: map of roleId → array of user objects
 *   - unassigned: users with no tag_ids matching any current role
 */
export const groupUsersByRole = (allUsers = [], roles = []) => {
  const roleIds = new Set(roles.map((r) => r.id));
  const byRole = {};
  const unassigned = [];

  // Initialize each role with an empty array
  for (const role of roles) {
    byRole[role.id] = [];
  }

  for (const user of allUsers) {
    const tagIds = user.user?.tag_ids || [];
    const matchingRoles = tagIds.filter((id) => roleIds.has(id));

    if (matchingRoles.length === 0) {
      unassigned.push(user);
    } else {
      for (const roleId of matchingRoles) {
        byRole[roleId].push(user);
      }
    }
  }

  return { byRole, unassigned };
};
